import { axios } from '../plugins/axios';

export default {
  namespaced: true,
  state: {
    estatusEstudios: [],
  },
  getters: {
    getEstatusEstudios: (state) => state.estatusEstudios,
  },
  mutations: {
    SET_ESTATUS_ESTUDIOS(state, estatusEstudios) {
      state.estatusEstudios = estatusEstudios;
    },
  },
  actions: {
    async fetchEstatusEstudios({ commit }) {
      await axios
        .get('/PoliciaCuadrantes/EstadoFuerza/estatusEstudios')
        .then((response) => {
          commit('SET_ESTATUS_ESTUDIOS', response.data.data);
        });
    },
  },
};
